"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const meetingTemplates = (0, graphql_tag_1.default)`
  query meetings_meetingTemplates($key: String) {
    meetings {
      meetingTemplates(key: $key) {
        title
        questions {
          id
          title
          description
          documents {
            id
            path
            name
            mimetype
          }
          questionItems {
            description
            documents {
              id
              path
              name
              mimetype
            }
          }
        }
      }
    }
  }
`;
exports.default = meetingTemplates;